import api, { apiErrorHandler } from "api";
import { DaHomeConstants } from "constants/constants";
import { RootState } from "reducers/rootReducer";
import { Dispatch } from "redux";

export const getCalendarData =
  (params: { user_id?: number | boolean; year?: number; week?: number }) =>
  (dispatch: Dispatch) => {
    const onError = () => dispatch({ type: DaHomeConstants.DA_HOME_ERROR });
    dispatch({ type: DaHomeConstants.DA_HOME_LOADING });
    api
      .getCalendarList(params)
      .then((res) => {
        if (res?.data) {
          dispatch({
            type: DaHomeConstants.DA_HOME_GET_DATA_SUCCESS,
            payload: res?.data,
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const homeSetFilter = (data: any) => (dispatch: Dispatch, getStore: () => RootState) => {
  const { homeFilters } = getStore()?.daHomeState;
  dispatch({
    type: DaHomeConstants.DA_HOME_SET_FILTERS,
    payload: { ...homeFilters, ...data },
  });
};
